<template>
  <div style="width:500px">
    <vue-editor :id="id" v-model="content"></vue-editor>
  </div>
</template>

<script>
import { VueEditor } from 'vue2-editor'

export default {
  name: 'RichText',
  components: {
    VueEditor
  },
  props: ['defaultValue', 'id'],
  methods: {
    update(value){
      this.$emit('input', value);
    }
  },
  data(){
    return {
      content: this.defaultValue || null
    }
  },
  watch: {
    content(newVal){
      this.update(newVal);
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/common/RichText.vue